/*
    Add here your own custom javascript ‍‍‌‌‍‌‍‍‌​​​‍‌​‍‌⁠‌​​‌‍​​‌‌‍​​‌​‍​​‌‌‍​​‌​‍‌​​​‍​​​​‍​​‌‌‍​​​​‍​​‌​‍​​​‌‍​‌‌​‍​​‌​﻿‍‌‌‍‍‍​‍​​‍​​‌‍​‍
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})


/* ELYPRO — playable demo video on product cards */
;(function () {
  var HOVER_DELAY = 300;

  function setup(card) {
    if (card.dataset.elyproBound === 'true') return;
    card.dataset.elyproBound = 'true';

    var video = card.querySelector('.elypro-card-video-el');
    var button = card.querySelector('.elypro-card-play');
    var wrapper = card.closest('.img-wrapper');
    var timer = null;

    if (!video) return;

    function prime() {
      if (video.dataset.elyproPrimed === 'true') return;
      video.dataset.elyproPrimed = 'true';
      video.preload = 'auto';
      try { video.load(); } catch (e) {}
    }

    function stop() {
      card.classList.remove('is-playing');
      try { video.pause(); video.currentTime = 0; } catch (e) {}
    }

    function play() {
      if (card.classList.contains('is-playing')) return;
      prime();
      card.classList.add('is-playing');
      try { video.currentTime = 0; } catch (e) {}
      var started = video.play();
      if (started && started.catch) started.catch(function () { stop(); });
    }

    video.addEventListener('ended', stop);

    card.addEventListener('pointerdown', prime, { passive: true });
    card.addEventListener('touchstart', prime, { passive: true });

    if (button) {
      button.addEventListener('pointerenter', prime, { passive: true });
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        play();
      });
    }

    if (wrapper && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      wrapper.addEventListener('mouseenter', function () {
        prime();
        clearTimeout(timer);
        timer = setTimeout(play, HOVER_DELAY);
      });
      wrapper.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        stop();
      });
    }

    card.elyproPlay = play;
    card.elyproPrime = prime;
  }

  function init() {
    var cards = document.querySelectorAll('[data-elypro-card]');
    for (var i = 0; i < cards.length; i++) setup(cards[i]);

    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (calm) return;
    if (!document.body.classList.contains('page-type-index')) return;
    if (!('IntersectionObserver' in window)) return;

    var first = document.querySelector('[data-elypro-card]');
    if (!first || !first.elyproPlay) return;

    var seen = false;
    var watcher = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !seen) {
          seen = true;
          watcher.disconnect();
          if (first.elyproPrime) first.elyproPrime();
          setTimeout(first.elyproPlay, 900);
        }
      }
    }, { threshold: 0.6 });

    watcher.observe(first);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
